import Pagination from './Pagination';

export default Pagination;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/pagination/index.js
// module id = 414
// module chunks = 0